import {
    Inject, IThree3DControllerConfiguration,
    IBaseController,
    Three3DBaseController,
    SoundType
} from "@denishussar/html5-game-engine";
import { GameLogic } from "../../Logic/GameLogic";

export interface IGameControllerOptions {
}


import { AmmoPhysics, Clock, ExtendedObject3D } from '@enable3d/ammo-physics'
import { PhysicsLoader } from '@enable3d/three-graphics'
import { GameModel } from "../../Models/GameModel";
import { GameEventsConstants } from "../../Constants/GameEventsConstants";
import { KykkaModel } from "../../Models/KykkaModel";
import KykkaSizeConstants from "../../Constants/KykkaSizeConstants";
import { Key } from "@denishussar/html5-game-engine";
import { HitState } from "../../Constants/HitState";
import { Line2 } from 'three/examples/jsm/lines/Line2.js';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
import { GeometryUtils } from 'three/examples/jsm/utils/GeometryUtils.js';

import THREE = require("three");
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { OBJLoader2 } from "three/examples/jsm/loaders/OBJLoader2";
import { Object3D } from "three";
import { KykkaState } from "../../Constants/KykaState";
import PhysicsBody from "@enable3d/common/dist/physicsBody";
import { CameraConstants } from "../../Constants/CameraConstants";
import { FieldTypeConstants } from "../../Constants/FieldTypeConstants";
import { Mesh } from "three";
import { PlayerTurnConstant } from "../../Constants/PlayerTurnConstant";
import PlayerSizeConstants from "../../Constants/PlayerSizeConstants";
import { SoundConstants } from "../../Constants/SoundConstants";
import { CameraHelpers } from "../../Helpers/Helpers";

var STATE = {
    ACTIVE: 1,
    ISLAND_SLEEPING: 2,
    WANTS_DEACTIVATION: 3,
    DISABLE_DEACTIVATION: 4,
    DISABLE_SIMULATION: 5
};

const mmTo3D = (mm) => mm * 15 / 5000;
const unit3DToMm = (unit) => unit * 5000 / 15;
export class Field3DController extends Three3DBaseController {
    $model: GameModel;
    private _kykkaItems: ExtendedObject3D[] = [];
    private _kykkaItemsB: ExtendedObject3D[] = [];
    private readonly _speed_delta: number = 0.1;
    private _hitAt: number;
    private _physics: AmmoPhysics;
    private _cube;
    private _controls;
    private _projectileControllerType: boolean = false;
    private _moveCameraOn: boolean = false;
    private _playerPxFactor: number = 0;
    private _offsetZ: number = 0;

    // lines
    private lineLeft: THREE.Mesh;
    private lineRight: THREE.Mesh;
    private lineAway: THREE.Mesh;
    private lineForward: THREE.Mesh;
    private lineKykkasA: THREE.Mesh;
    private lineKykkasB: THREE.Mesh;

    //TODO : remvoe
    private _cP = {x: 0, y: 25.9, z: -49.5}
    private _cR = {x: -2.709, y: 0, z: -3.14}
    private _debugLine: any;

    private _hitState: HitState = HitState.Idle;
    private _arrayDirectionsOfProjectile: THREE.Object3D[] = [];

    private _sceneObjects: {
        [key: string]: {
            source: string;
            object: Object3D
        }
    } = {
            baseball_bat: {
                source: 'assets/3d/bat.obj',
                object: null
            }
        };

    public constructor(@Inject private _options: IGameControllerOptions,
        @Inject private _gameLogic: GameLogic) {
        super("Field3DController");
        console.log(this);

    }

    private get _areKykkasStopped() {
        const kykkas = this._gameLogic.isPlayerTurn ? this._kykkaItems : this._kykkaItemsB;
        const res = kykkas.some((item, index) => {
            const velocity = item.userData.physicsBody.getLinearVelocity();
            const res = this.$model.kykkaItems[index].state !== KykkaState.OutCity
                && (Math.abs(velocity.x()) > this._speed_delta
                    || Math.abs(velocity.y()) > this._speed_delta
                    || Math.abs(velocity.z()) > this._speed_delta);
            return res;
        });
        return !res;
    }

    private get _clubX0() {
        const sign = (this._gameLogic.isPlayerTurn ? 1 : -1);
        const deltaX = sign * (this._gameLogic.currentPlayer.isRightHand ? 1 : -1) * mmTo3D(PlayerSizeConstants.handSize);
        return deltaX + sign * mmTo3D(this._gameLogic.currentPlayer.x3d);
    }

    private get _clubZ0() {
        if (this._gameLogic.currentPlayer.kykkaTouched) {
            return (this._gameLogic.isPlayerTurn ? -1 : 1) * mmTo3D(this.$model.fieldSize.length);
        }
        return 0;
    }

    private get _cameraSwitchDistance() {
        if(this._gameLogic.isPlayerTurn) {
            return mmTo3D(0.6 * this.$model.fieldSize.distance);
        } else {
            return mmTo3D(0.4 * this.$model.fieldSize.distance);
        }
    }

    protected getConfiguration(): IThree3DControllerConfiguration {

        return {
            childControllers: {},
            modelWatch: {
                kykkaItems: (items) => this.initializationPiecesPlayingField(),
                kykkaItemsB: (items) => {
                    this._initBotKykkas();
                },
                cameraIndex: (cameraIndex: number) => {
                    console.log('cameraIndex', CameraConstants[ cameraIndex ]);

                    this._setCamera(cameraIndex);
                },
                currentTurn: (currentTurn: PlayerTurnConstant) => {
                    this._setKykkasAvailability(currentTurn);
                },
                isGameReady: (ready: boolean) => {
                    if(ready) {
                        this._setKykkasAvailability(this.$model.currentTurn);
                        this._positioning3DFieldLines();
                    }
                },
                isFreeField: (isFreeField: boolean) => {
                    this._resetField(isFreeField);
                },
            },
            modelEvents: {
                [GameEventsConstants.hitStart]: () => {
                    this.projectileThrowRun(GameEventsConstants.hitStart);
                    this._projectileControllerType = false;
                    this.createPositionProjectile();
                },
                [GameEventsConstants.directionChangeStart]: () => {
                    this._projectileControllerType = true;
                    this.createPositionProjectile();
                },
                [GameEventsConstants.preventStart]: () => {
                    this.removeProjectile();
                },
            },
            queue: {
                hitEnd: {
                    condition: (clock) => clock > 2,
                    action: () => {
                        this._gameLogic.hitEnd();
                    }
                }
            },
            sounds: [
                {
                    id: SoundConstants.KYKKA_HIT,
                    type: SoundType.SFX
                }
            ]
        };
    }
    private _initBotKykkas() {
        this._kykkaItemsB = this._castKykkasSet(this.$model.kykkaItemsB, 0x3333C5);
    }

    protected async onInitialize() {
        // light
        //this.scene.add(new THREE.HemisphereLight(0xffffbb, 0x080820, 1));
        //this.scene.add(new THREE.AmbientLight(0x666666));

        // physics
        this._physics = new AmmoPhysics(this.scene);
        // this._physics.debug.enable();

        // extract the object factory from physics
        // the factory will make/add object without physics
        const { factory } = this._physics;

        // static ground
        // this._physics.add.ground({
        //     width: 20,
        //     height: 50,
        //     depth: 1,
        //     y: -0.5
        // });

        // const wireframeMaterial = new THREE.MeshBasicMaterial( { color: 0x00ee00, wireframe: true, transparent: true } );
        const wireframeMaterial = new THREE.MeshLambertMaterial({ color: 0x008cf0 });

        const floorMaterial = new THREE.MeshStandardMaterial({ color: 0xF1F1F1 });
        const floor = new THREE.Mesh(new THREE.BoxGeometry(20, 1, 50), wireframeMaterial);
        floor.position.y = -0.5;
        floor.receiveShadow = true;
        floor.castShadow = true;
        const groundShape = new Ammo.btBoxShape(new Ammo.btVector3(500, 1, 500)); // Create block 50x2x50
        const groundTransform = new Ammo.btTransform();
        groundTransform.setIdentity();
        groundTransform.setOrigin(new Ammo.btVector3(0, -1, 0)); // Set initial position
        const groundMass = 0; // Mass of 0 means ground won't move from gravity or collisions
        const localInertia = new Ammo.btVector3(0, 0, 0);
        const motionState = new Ammo.btDefaultMotionState(groundTransform);
        const rbInfo = new Ammo.btRigidBodyConstructionInfo(groundMass, motionState, groundShape, localInertia);
        rbInfo.set_m_restitution(0);
        let groundAmmo = new Ammo.btRigidBody(rbInfo);

        this._physics.physicsWorld.addRigidBody(groundAmmo);
        // @ts-ignore
        // this.scene.add(floor);

        //create walls
        this._createWall(0, 20, -50, 500, 20, 1);
        this._createWall(-20, 20, -10, 1, 20, 500);
        this._createWall(20, 20, -10, 1, 20, 500);

        // this._gameLogic.setCamera(this.$model.cameraIndex);


        // this.initializationPiecesPlayingField(material);

        if (this._moveCameraOn) {
            super.onLandscape();
            this._initializeOrbitControlSettings();
        }

        const loader = new THREE.TextureLoader();
        loader.load('assets/3d/color.png', this._onTextureLoad.bind(this));
        this.initializationPiecesPlayingField();
        this._initBotKykkas();
        this._create3DFieldLines();
        if (this.$model.isGameReady) {
            this._setKykkasAvailability(this.$model.currentTurn);
        }
        this._positioning3DFieldLines();
    }

    private _resetField(isFreeField: boolean) {
        if (isFreeField) {
            const kykkas = this._kykkaItems.concat(this._kykkaItemsB);
            for (const kykka of kykkas) {
                this._physics.physicsWorld.removeCollisionObject(kykka.userData.physicsBody);
                this.scene.remove(kykka);
            }

            // биту просто прячем за вьюпорт
            const physicsBody = (<Ammo.btRigidBody>this._cube.userData.physicsBody);
            const tr = physicsBody.getWorldTransform();
            tr.setOrigin(new Ammo.btVector3(-40, 0, 0));
        }
    }

    private _onTextureLoad(texture) {
        const material = new THREE.MeshPhongMaterial({ map: texture, });
        const loader = new THREE.TextureLoader();

        Object.keys(this._sceneObjects).forEach((key) => {
            // @ts-ignore
            let loader = new OBJLoader2();
            loader.crossOrigin = '';
            loader.load(this._sceneObjects[key].source, (object3d) => {

                object3d.scale.set(0.04, 0.04, 0.04);
                this._sceneObjects[key].object = object3d;


                //
                // const material = new THREE.MeshPhongMaterial( { color: 0xDCC189 } );
                // const darkMaterial = new THREE.MeshBasicMaterial( { color: 0xC4AD6F });
                // const multiMaterial = [ darkMaterial, material, material ];
                // const mesh = new THREE.Mesh(new THREE.CylinderGeometry(
                //     mmTo3D(50),
                //     mmTo3D(50),
                //     mmTo3D(1000),
                //     12
                // ), material);
                //


                //TODO need to use object3d
                this._cube = this._sceneObjects.baseball_bat.object;
                //add texture
                this._cube.traverse(function (node) {
                    if (node.isMesh) node.material = material;
                });

                const cylinderBufferGeometryTop = new THREE.CylinderBufferGeometry(
                    mmTo3D(50),
                    mmTo3D(50),
                    mmTo3D(840), 5);
                const cylinderBufferGeometryBottom = new THREE.CylinderBufferGeometry(
                    mmTo3D(35),
                    mmTo3D(35),
                    mmTo3D(300), 5);

                const cylinderMesh = this.getGeometryMesh(cylinderBufferGeometryTop);
                const cylinderMesh2 = this.getGeometryMesh(cylinderBufferGeometryBottom);

                const group = new Ammo.btCompoundShape(true);
                const cPos1 = new Ammo.btVector3(0, mmTo3D(130), 0);
                const cQuat1 = new Ammo.btQuaternion(0, 0, 0, 1);
                const cPos2 = new Ammo.btVector3(0, -1 * mmTo3D(410), 0);
                const cQuat2 = new Ammo.btQuaternion(0, 0, 0, 5);
                let shapeTop = new Ammo.btConvexTriangleMeshShape(cylinderMesh, true);
                let shapeBottom = new Ammo.btConvexTriangleMeshShape(cylinderMesh2, true);

                group.addChildShape(new Ammo.btTransform(cQuat1, cPos1), shapeTop);
                group.addChildShape(new Ammo.btTransform(cQuat2, cPos2), shapeBottom);

                const pos = new THREE.Vector3(0, 1, 118);
                const quat = new THREE.Quaternion(0, 0, 0, 1);
                const body = this._makeRigidBody(group, 8, pos, quat);

                this._physics.addRigidBodyToWorld(this._cube, body, 0, 1, -1, false, undefined);
                this._cube.body = new PhysicsBody(this._physics, body);
                this._cube.userData.physicsBody = body;
                this._cube.body.name = "club";
                this._cube.body.ammo.name = this._cube.body.name;
                this._cube.name = this._cube.body.name;
                this._cube.body.on.collision((obj, eventName) => {
                    if (eventName === "start" && this._hitState !== HitState.Idle) {
                        this.$sounds.get(SoundConstants.KYKKA_HIT).playSound(0, 0.05);
                        console.log(
                            eventName,
                            obj.name,
                            Math.sqrt(
                                this._cube.body.velocity.x * this._cube.body.velocity.x +
                                this._cube.body.velocity.y * this._cube.body.velocity.y +
                                this._cube.body.velocity.z * this._cube.body.velocity.z)
                        );
                    }
                });

                /* for debug club position and shadow
                const physicsBody = (<Ammo.btRigidBody>this._cube.userData.physicsBody);

                const tr = physicsBody.getWorldTransform();

                tr.setIdentity();
                tr.setOrigin(new Ammo.btVector3(this._clubX0, 2, 2));
                tr.setRotation(new Ammo.btQuaternion(0, 0, -1, 1));
                // physicsBody.getCenterOfMassTransform().getOrigin().setZ(2)


                */
               this.scene.add(this._cube);

            });
        });

    }

    createRigidBodyByMesh(sx, sy, sz, mass, pos, quat, material, mesh, threeObject) {

        let shape = new Ammo.btConvexTriangleMeshShape(mesh, true);

        this.createRigidBody(threeObject, shape, mass, pos, quat);

        return threeObject;

    }

    private _makeRigidBody(shape, mass, pos, quat) {

        const transform = new Ammo.btTransform();
        transform.setIdentity();
        transform.setOrigin(new Ammo.btVector3(pos.x, pos.y, pos.z));
        transform.setRotation(new Ammo.btQuaternion(quat.x, quat.y, quat.z, quat.w));
        const motionState = new Ammo.btDefaultMotionState(transform);

        const localInertia = new Ammo.btVector3(0, 0, 0);
        shape.calculateLocalInertia(mass, localInertia);

        const rbInfo = new Ammo.btRigidBodyConstructionInfo(mass, motionState, shape, localInertia);
        return new Ammo.btRigidBody(rbInfo);
    }

    createRigidBody(threeObject, physicsShape, mass, pos, quat) {

        threeObject.position.copy(pos);
        threeObject.quaternion.copy(quat);

        const transform = new Ammo.btTransform();
        transform.setIdentity();
        transform.setOrigin(new Ammo.btVector3(pos.x, pos.y, pos.z));
        transform.setRotation(new Ammo.btQuaternion(quat.x, quat.y, quat.z, quat.w));
        const motionState = new Ammo.btDefaultMotionState(transform);

        const localInertia = new Ammo.btVector3(0, 0, 0);
        physicsShape.calculateLocalInertia(mass, localInertia);

        const rbInfo = new Ammo.btRigidBodyConstructionInfo(mass, motionState, physicsShape, localInertia);
        const body = new Ammo.btRigidBody(rbInfo);
        // body.setActivationState(0);
        // body.setCollisionFlags(body.getCollisionFlags()  | 4);
        // body.activate(false);

        //TODO
        const enabled3dBody = new PhysicsBody(this._physics, body)
        // enabled3dBody.setCollisionFlags(enabled3dBody.getCollisionFlags() | Ammo.btCollisionObject.);
        // body.setCollisionShape(new Ammo.btBoxShape(new Ammo.btVector3(0, 0, 0)));
        // body.setLinearVelocity(new Ammo.btVector3(0, 0, 0));
        threeObject.body = enabled3dBody;
        threeObject.userData.physicsBody = body;

        this.scene.add(threeObject);

        if (mass > 0) {

            // Disable deactivation
            //body.setActivationState(4);

        }

        // this._physics.physicsWorld.addRigidBody(body);
        // this._physics.addRigidBodyToWorld(threeObject, body, 0, 1, -1, false, undefined)

        return body;
    }

    getGeometryMesh(bufGeometry) {


        // Obtain a Geometry
        const geometry = new THREE.Geometry().fromBufferGeometry(bufGeometry);

        // Merge the vertices so the triangle soup is converted to indexed triangles
        const vertsDiff = geometry.mergeVertices();

        // Convert again to BufferGeometry, indexed
        const indexedBufferGeom = this.getVerticesAndIndices(geometry);

        const scale = [1, 1, 1];

        const mesh = new Ammo.btTriangleMesh(true, true);
        mesh.setScaling(new Ammo.btVector3(scale[0], scale[1], scale[2]));

        const vertices = indexedBufferGeom.vertices;
        const indices = indexedBufferGeom.indices;
        for (let i = 0; i * 3 < indices.length; i++) {
            mesh.addTriangle(
                new Ammo.btVector3(vertices[indices[i * 3] * 3], vertices[indices[i * 3] * 3 + 1], vertices[indices[i * 3] * 3 + 2]),
                new Ammo.btVector3(vertices[indices[i * 3 + 1] * 3], vertices[indices[i * 3 + 1] * 3 + 1], vertices[indices[i * 3 + 1] * 3 + 2]),
                new Ammo.btVector3(vertices[indices[i * 3 + 2] * 3], vertices[indices[i * 3 + 2] * 3 + 1], vertices[indices[i * 3 + 2] * 3 + 2]),
                false
            );
        }

        return mesh;
    }

    getVerticesAndIndices(geometry) {

        const numVertices = geometry.vertices.length;
        const numFaces = geometry.faces.length;

        const vertices = new Float32Array(numVertices * 3);
        const indices = new (numFaces * 3 > 65535 ? Uint32Array : Uint16Array)(numFaces * 3);

        for (let i = 0; i < numVertices; i++) {

            const p = geometry.vertices[i];

            const i3 = i * 3;

            vertices[i3] = p.x;
            vertices[i3 + 1] = p.y;
            vertices[i3 + 2] = p.z;

        }

        for (let i = 0; i < numFaces; i++) {

            const f = geometry.faces[i];

            const i3 = i * 3;

            indices[i3] = f.a;
            indices[i3 + 1] = f.b;
            indices[i3 + 2] = f.c;

        }

        return {
            indices: indices,
            vertices: vertices
        };
    }

    /**
     * Creating objects for tracking aiming
     */
    createPositionProjectile(): void {
        if (this._projectileControllerType) {

            //let color = 0xA9D864;
            let color = 0xFFFFFF;
            console.log('createPositionProjectile');
            for (let i = 0; i < 10; i++) {
                const geometry = new THREE.SphereBufferGeometry(0.25 - i / 50, 32, 32);
                const material = new THREE.MeshBasicMaterial({ color: color });
                color -= 0x001010;
                const mesh = new THREE.Mesh(geometry, material);
                // mesh.position.set(5, 1, 25 + i * -2);
                this._arrayDirectionsOfProjectile.push(mesh);
            }
            if (this._arrayDirectionsOfProjectile.length) {
                this._arrayDirectionsOfProjectile.forEach((item) => {

                    // @ts-ignore
                    this.scene.add(item);
                })
            }
        }
        else {
            this.removeProjectile();
        }

    }

    removeProjectile(): void {
        //TODO need hidden
        this._arrayDirectionsOfProjectile.forEach((item) => {
            // @ts-ignore
            this.scene.remove(item);
        });
        this._arrayDirectionsOfProjectile = [];
    }

    /**
     * Updating objects for tracking aiming
     */
    positionUpdateProjectile(): void {
        const player = this._gameLogic.currentPlayer;
        const revers = player.angleY > 0 ? 1 : -1;
        const adjustmentPositionX = (this._gameLogic.isPlayerTurn ? 1 : -1) * player.angleX  * revers;
        const getZPosition = (index) => {
            return this._clubZ0 + (this._gameLogic.isPlayerTurn
                ? mmTo3D(this.$model.fieldSize.distance + this.$model.fieldSize.length) + index * -Math.abs(player.angleY)
                : -(mmTo3D(this.$model.fieldSize.length) + index * -Math.abs(player.angleY)));
        };

        const getYPosition = (index) => {
            //TODO fix finish item position
            return 1.5 + index * index / 15;
        };

        if (this._arrayDirectionsOfProjectile.length) {
            this._arrayDirectionsOfProjectile.forEach((item, index) => {
                const positionX = this._clubX0 + player.angleX + index * adjustmentPositionX;
                const positionY = revers < 0 ? getYPosition(index) : 1.5;
                const positionZ = getZPosition(index);
                item.position.set(positionX, positionY, positionZ);
            });
        }

    }

    /**
     * Throw the game projectile
     * @param event
     */
    projectileThrowRun(event): void {
        const player = this._gameLogic.currentPlayer;
        const ratioStrength = -50;
        const variationCoefficient = 55;

        const forceZ = player.power * ratioStrength;

        const reversePositionStick = player.angleY < 0 ? -1 : 1;

        const yDirection = player.angleY > 0 ? 25 : (10 + -player.angleY * 40);
        const zDirection = player.angleY * variationCoefficient * reversePositionStick;
        const xDirection = player.angleX * variationCoefficient * reversePositionStick;
        console.log('xDirection', player.angleX * variationCoefficient, player.angleX, variationCoefficient, player.angleY );

        if (event === GameEventsConstants.hitStart || (event.code && event.code === "Space")) {

            const physicsBody = (<Ammo.btRigidBody>this._cube.userData.physicsBody);

            const tr = physicsBody.getWorldTransform();

            const z = this._clubZ0 + (this._gameLogic.isPlayerTurn
                ? mmTo3D(this.$model.fieldSize.distance + this.$model.fieldSize.length)
                : -mmTo3D(this.$model.fieldSize.length))
            tr.setIdentity();
            tr.setOrigin(new Ammo.btVector3(this._clubX0, 1.5, z));
            tr.setRotation(new Ammo.btQuaternion(0, 0, (this._gameLogic.isPlayerTurn ? -1 : 1), 1));

            physicsBody.setLinearVelocity(new Ammo.btVector3(0, 0, 0));
            physicsBody.setAngularVelocity(new Ammo.btVector3(0, 0, 0));
            physicsBody.activate();

            this._hitState = HitState.Started;
            this._hitAt = Date.now();

            setTimeout(() => {
                const impulseDir = this._gameLogic.isPlayerTurn ? -1 : 1;
                physicsBody.applyImpulse(new Ammo.btVector3(-impulseDir * xDirection * 2, yDirection, impulseDir * zDirection * 2 - 20), new Ammo.btVector3(-impulseDir * 0.7, 0, 0));

                // physicsBody.applyCentralImpulse(new Ammo.btVector3(xDirection*2, yDirection*2, 0));

                physicsBody.applyImpulse(new Ammo.btVector3(-impulseDir * xDirection * 2, yDirection, impulseDir * zDirection * 2), new Ammo.btVector3(impulseDir * 0.7, 0, 0));

            }, 100);

        }
    }

    /**
     * Initialization of the playing field and placement of pieces on the platform
     * @param material
     */
    initializationPiecesPlayingField(): void {
        this._kykkaItems = this._castKykkasSet(this.$model.kykkaItems, 0xC53333);
        this._gameLogic.setFieldZoom(false);
    }

    /**
     * Method for setting up a controlled camera for easy positioning of objects on a 3D scene
     * @private
     */
    private _initializeOrbitControlSettings(): void {
        // @ts-ignore
        this._controls = new OrbitControls(this.camera, this.renderer.renderer3d.domElement);
        this._controls.enableZoom = true;
        this._controls.enablePan = true;
        this._controls.enableRotate = true;
    }

    protected onLandscape(): void {
        if (!this._moveCameraOn) {
            super.onLandscape();
        }

        this._setCamera(this.$model.cameraIndex);
    }

    protected onPortrait(): void {
        super.onPortrait();

        //this.camera.position.y += 6;

        // this._setCamera(this.$model.cameraIndex);
    }

    protected onResize(width: number, height: number, scale: number): void {

    }


    protected onUpdate(frameRate: number): void {
        if (this.$model.pause) {
            return;
        }
        this.positionUpdateProjectile();
        this._physics.update(frameRate * 1000);
        this._physics.updateDebugger();

        if (this._cube) { //TODO: move to method
            const physicsBody = (<Ammo.btRigidBody>this._cube.userData.physicsBody);

            const origin = physicsBody.getCenterOfMassTransform().getOrigin();
            const rotation = physicsBody.getCenterOfMassTransform().getRotation();
            this._cube.position.x = origin.x();
            this._cube.position.y = origin.y();
            this._cube.position.z = origin.z();
            this._cube.quaternion.set(rotation.x(), rotation.y(), rotation.z(), rotation.w());
            //this._cube.rotation.z += Math.PI/2;

            const velocity = physicsBody.getLinearVelocity();
            const isCrossedZoomLine = (this._gameLogic.isPlayerTurn)
                ? this._cube.position.z < this._cameraSwitchDistance
                : this._cube.position.z > this._cameraSwitchDistance;
            if (isCrossedZoomLine && this._hitState === HitState.Started) {
                this._gameLogic.setFieldZoom(true);
                this._hitState = HitState.Anticipation;
            } else if ((this._hitState === HitState.Anticipation || (this._hitState === HitState.Started && Date.now() - this._hitAt > 4000))
                && Math.abs(velocity.x()) < this._speed_delta
                && Math.abs(velocity.y()) < this._speed_delta
                && Math.abs(velocity.z()) < this._speed_delta
                && this._areKykkasStopped) {
                this.$queue.get("hitEnd").addToQueue(1, {});
                this._hitState = HitState.Ended;
            }
        }

        if (this._kykkaItems.length && this._gameLogic.isPlayerTurn) {
            const kykaModelList = this._kykkaItems.map(this._mapAndUpdateKykkaItem);
            this._gameLogic.updateKykkas(kykaModelList);
        }

        if (this._kykkaItemsB.length && !this._gameLogic.isPlayerTurn) {
            const kykaModelList = this._kykkaItemsB.map(this._mapAndUpdateKykkaItem);
            this._gameLogic.updateKykkasB(kykaModelList);
        }
    }

    private _mapAndUpdateKykkaItem(kykka: ExtendedObject3D, i: number) {
            const kykkaModel = {
                x: unit3DToMm(kykka.position.x),
                y: unit3DToMm(kykka.position.y),
                z: unit3DToMm(kykka.position.z),
                rotationX: kykka.rotation.x,
                rotationY: kykka.rotation.y,
                rotationZ: kykka.rotation.z
            };
            const origin = kykka.userData.physicsBody.getCenterOfMassTransform().getOrigin();
            const rotation = kykka.userData.physicsBody.getCenterOfMassTransform().getRotation();
            kykka.position.x = origin.x();
            kykka.position.y = origin.y();
            kykka.position.z = origin.z();
            kykka.quaternion.set(rotation.x(), rotation.y(), rotation.z(), rotation.w());
            return kykkaModel;
    }

    private _createKyka(x, y, z, material, index) {
        const pos = new THREE.Vector3();
        const quat = new THREE.Quaternion();

        pos.set(x, y, z);
        quat.set(0, 0, 0, 1);


        const cylinderBufferGeometry = new THREE.CylinderBufferGeometry(
            mmTo3D(0.5 * KykkaSizeConstants.diameter),
            mmTo3D(0.5 * KykkaSizeConstants.diameter),
            mmTo3D(KykkaSizeConstants.height), 5);

        const cylinderShape = this.getGeometryMesh(cylinderBufferGeometry);

        const kykkaGeometry = new THREE.Mesh(new THREE.CylinderGeometry(
            mmTo3D(0.6 * KykkaSizeConstants.diameter),
            mmTo3D(0.6 * KykkaSizeConstants.diameter),
            mmTo3D(KykkaSizeConstants.height + 10),
            16
        ), material);
        const kykka = this.createRigidBodyByMesh(1, 1, 1, 1, pos, quat, material, cylinderShape, kykkaGeometry);

        kykka.body.name = "kykka-" + index;
        kykka.body.ammo.name = kykka.body.name;
        kykka.name = kykka.body.name;
        kykka.visible = false;
        return kykka;
    }

    private _setCamera(num: CameraConstants) {
        switch (num) {
            case CameraConstants.SmallAway:
                this.camera.position.set(0, 17.5, 57.3);
                this.camera.rotation.set(-0.35, 0, 0);
                break;
            case CameraConstants.SmallBack:
                this.camera.position.set(0, 22, 45.5);
                this.camera.rotation.set(-0.5, 0, 0);
                break;
            case CameraConstants.SmallClose:
                this.camera.position.set(0, 17, 31);
                this.camera.rotation.set(-0.5, 0, 0);
                break;


            case CameraConstants.MediumAway:
                this.camera.position.set(0, 25.9, 73.4);
                this.camera.rotation.set(-0.433, 0, 0);
                break;
            case CameraConstants.MediumBack:
                this.camera.position.set(0, 25.9, 61.4);
                this.camera.rotation.set(-0.433, 0, 0);
                break;
            case CameraConstants.MediumClose:
                this.camera.position.set(0, 20, 37);
                this.camera.rotation.set(-0.433, 0, 0);
                break;

            case CameraConstants.BigAway:
                this.camera.position.set(0, 26, 82.5);
                this.camera.rotation.set(-0.433, 0, 0);
                break;
            case CameraConstants.BigBack:
                this.camera.position.set(0, 26, 67.5);
                this.camera.rotation.set(-0.433, 0, 0);
                break;
            case CameraConstants.BigClose:
                this.camera.position.set(0, 22, 45);
                this.camera.rotation.set(-0.5, 0, 0);
                break;

            /**
             * Bot's camera
             */
            case CameraConstants.SmallAwayB:
                this.camera.position.set(0, 17.5, -39.3);
                this.camera.rotation.set(-(Math.PI - 0.35), 0, -3.14);
                break;
            case CameraConstants.SmallBackB:
                this.camera.position.set(0, 22, -27.5);
                this.camera.rotation.set(-(Math.PI - 0.5), 0, -3.14);
                break;
            case CameraConstants.SmallCloseB:
                this.camera.position.set(0, 17, -13);
                this.camera.rotation.set(-(Math.PI - 0.5), 0, -3.14);
                break;

            case CameraConstants.MediumAwayB:
                this.camera.position.set(-0.02, 25.7, -49.2);
                this.camera.rotation.set(-(Math.PI - 0.433), 0, -3.14);
                break;
            case CameraConstants.MediumCloseB:
                this.camera.position.set(-0.02, 20, -13.5);
                this.camera.rotation.set(-(Math.PI - 0.433), 0, -3.14);
                break;
            case CameraConstants.MediumBackB:
                this.camera.position.set(-0.02, 25.7, -37.3);
                this.camera.rotation.set(-(Math.PI - 0.433), 0, -3.14);
                break;
            case CameraConstants.MediumCloseB:
                this.camera.position.set(0.05, 25.7, -14.6);
                this.camera.rotation.set(-2.61, 0, -3.14);
                break;

            case CameraConstants.BigAwayB:
                this.camera.position.set(0, 26, -52.5);
                this.camera.rotation.set(-(Math.PI - 0.433), 0, -3.14);
                break;
            case CameraConstants.BigBackB:
                this.camera.position.set(0, 26, -37.5);
                this.camera.rotation.set(-(Math.PI - 0.433), 0, -3.14);
                break;
            case CameraConstants.BigCloseB:
                this.camera.position.set(0, 22, -15);
                this.camera.rotation.set(-(Math.PI - 0.5), 0, -3.14);
                break;
        }

        if (this._cube && !CameraHelpers.isCameraZoomed(num)) {
            // спрячем биту за пределми видимости игрока
            const physicsBody = (<Ammo.btRigidBody>this._cube.userData.physicsBody);
            physicsBody.getWorldTransform().setOrigin(new Ammo.btVector3(0, 0, 200));
        }
    }

    private _createWall(x, y, z, w, h, d) {
        const wallMaterial = new THREE.MeshStandardMaterial({ color: 0xff00ff });
        const width = Math.min(20, w);
        const height = Math.min(20, h);
        const depth = Math.min(20, d);
        const wall = new THREE.Mesh(new THREE.BoxGeometry(width, height, depth), wallMaterial);
        wall.position.x = x;
        wall.position.y = y - 0.5 * height;
        wall.position.z = z - 0.5 * depth;
        const wallShape = new Ammo.btBoxShape(new Ammo.btVector3(w, h, d));
        const wallTransform = new Ammo.btTransform();
        wallTransform.setIdentity();
        wallTransform.setOrigin(new Ammo.btVector3(x, y, z));
        const wallMass = 0;
        const localInertia = new Ammo.btVector3(0, 0, 0);
        const motionState = new Ammo.btDefaultMotionState(wallTransform);
        const rbFrontWallInfo = new Ammo.btRigidBodyConstructionInfo(wallMass, motionState, wallShape, localInertia);
        rbFrontWallInfo.set_m_restitution(0);
        let frontWallAmmo = new Ammo.btRigidBody(rbFrontWallInfo);
        this._physics.physicsWorld.addRigidBody(frontWallAmmo);

        // @ts-ignore
        //this.scene.add(wall);
    }

    private _onCollision(targetName, obj, eventName) {
        if (eventName === "start" && this._hitState !== HitState.Idle) {
            console.log(targetName, obj);
            this._gameLogic.setCurrentPlayerKykkaTouched(true);
        }
    }

    private _castKykkasSet(kykkaItems: KykkaModel[], color: number) {
        const material = new THREE.MeshPhongMaterial({ color: 0xDCC189 });
        const darkMaterial = new THREE.MeshBasicMaterial({ color });
        const multiMaterial = [darkMaterial, material, material];
        // const phongMaterial = new THREE.MeshPhongMaterial({ color: 0x0000dd, specular: 0x009900, shininess: 60 });
        const list = kykkaItems.map((kykkaModel, index) => {
            const x = mmTo3D(kykkaModel.x);
            const y = mmTo3D(kykkaModel.y);
            const z = mmTo3D(kykkaModel.z);

            const kykka = this._createKyka(x, y, z, multiMaterial, index);
            kykka.body.on.collision(this._onCollision.bind(this, kykka.body.name));
            return kykka;
        });

        return list;
    }

    private _hideKykkas(list: ExtendedObject3D[]) {
        list.forEach(kykka => {
            kykka.visible = false;
            this._physics.physicsWorld.removeCollisionObject(kykka.userData.physicsBody);
        })
    }

    private _showKykkas(list: ExtendedObject3D[]) {
        list.forEach(kykka => {
            kykka.visible = true;
            const body = kykka.userData.physicsBody as Ammo.btRigidBody;
            this._physics.addRigidBodyToWorld(kykka, body, 0, 1, -1, false, undefined)
        })
    }

    private _setKykkasAvailability(currentTurn: PlayerTurnConstant) {
        if (currentTurn === PlayerTurnConstant.A) {
            this._hideKykkas(this._kykkaItemsB);
            this._showKykkas(this._kykkaItems);
        } else {
            this._hideKykkas(this._kykkaItems);
            this._showKykkas(this._kykkaItemsB);
        }
    }

    private _create3DFieldLines() {
        let geometry: THREE.BoxGeometry;
        let material: THREE.MeshBasicMaterial;
        const { width, distance, length, lineWidth } = this.$model.fieldSize;
        const sideLength = mmTo3D(2 * length + distance);
        const lineHeight = 0.1;
        const color = 0xffffff;
        const lineWidth3D = mmTo3D(lineWidth);
        const crossLine = mmTo3D(width);
        const oneMeter = mmTo3D(1000);

        // left side
        geometry = new THREE.BoxGeometry(lineWidth3D, lineHeight, oneMeter);
        // geometry = new THREE.BoxGeometry(lineWidth3D, lineHeight, sideLength + lineWidth3D);
        material = new THREE.MeshBasicMaterial({ color, wireframe: false});
        this.lineLeft = new THREE.Mesh(geometry, material);

        // right side
        geometry = new THREE.BoxGeometry(lineWidth3D, lineHeight, oneMeter);
        // geometry = new THREE.BoxGeometry(lineWidth3D, lineHeight, sideLength + lineWidth3D);
        material = new THREE.MeshBasicMaterial({ color, wireframe: false});
        this.lineRight = new THREE.Mesh(geometry, material);

        // away line
        geometry = new THREE.BoxGeometry(oneMeter, lineHeight, lineWidth3D);
        // geometry = new THREE.BoxGeometry(crossLine + lineWidth3D, lineHeight, lineWidth3D);
        material = new THREE.MeshBasicMaterial({ color, wireframe: false });
        this.lineAway = new THREE.Mesh(geometry, material);

        // forward line
        geometry = new THREE.BoxGeometry(oneMeter, lineHeight, lineWidth3D);
        // geometry = new THREE.BoxGeometry(crossLine + lineWidth3D, lineHeight, lineWidth3D);
        material = new THREE.MeshBasicMaterial({ color, wireframe: false });
        this.lineForward = new THREE.Mesh(geometry, material);

        // player kykka line
        geometry = new THREE.BoxGeometry(oneMeter, lineHeight, lineWidth3D);
        // geometry = new THREE.BoxGeometry(crossLine + lineWidth3D, lineHeight, lineWidth3D);
        material = new THREE.MeshBasicMaterial({ color, wireframe: false });
        this.lineKykkasA = new THREE.Mesh(geometry, material);


        // bot kykka line
        geometry = new THREE.BoxGeometry(oneMeter, lineHeight, lineWidth3D);
        // geometry = new THREE.BoxGeometry(crossLine + lineWidth3D, lineHeight, lineWidth3D);
        material = new THREE.MeshBasicMaterial({ color, wireframe: false });
        this.lineKykkasB = new THREE.Mesh(geometry, material);

        // @ts-ignore
        this.scene.add(this.lineLeft);
        // @ts-ignore
        this.scene.add(this.lineRight);
        // @ts-ignore
        this.scene.add(this.lineAway);
        // @ts-ignore
        this.scene.add(this.lineForward);
        // @ts-ignore
        this.scene.add(this.lineKykkasA);
        // @ts-ignore
        this.scene.add(this.lineKykkasB);
    }

    private _positioning3DFieldLines() {
        const { width, distance, length, lineWidth } = this.$model.fieldSize;
        const y = -0.05;
        const oneMeter = mmTo3D(1000);
        const sideLength = mmTo3D(2 * length + distance);
        const lineWidth3D = mmTo3D(lineWidth);
        const crossLine = mmTo3D(width);

        //
        this.lineLeft.position.x = -mmTo3D(0.5 * width);
        this.lineLeft.position.y = y;
        this.lineLeft.position.z = mmTo3D(0.5 * distance);
        this.lineLeft.scale.z = (sideLength + lineWidth3D) / oneMeter;

        //
        this.lineRight.position.x = mmTo3D(0.5 * width);
        this.lineRight.position.y = y;
        this.lineRight.position.z = mmTo3D(0.5 * distance);
        this.lineRight.scale.z = (sideLength + lineWidth3D) / oneMeter;

        //
        this.lineAway.position.x = 0;
        this.lineAway.position.y = y;
        this.lineAway.position.z = -mmTo3D(length);
        this.lineAway.scale.x = (crossLine + lineWidth3D) / oneMeter;

        //
        this.lineForward.position.x = 0;
        this.lineForward.position.y = y;
        this.lineForward.position.z = mmTo3D(length + distance);
        this.lineForward.scale.x = (crossLine + lineWidth3D) / oneMeter;

        //
        this.lineKykkasA.position.x = 0;
        this.lineKykkasA.position.y = y;
        this.lineKykkasA.position.z = 0;
        this.lineKykkasA.scale.x = (crossLine + lineWidth3D) / oneMeter;

        //
        this.lineKykkasB.position.x = 0;
        this.lineKykkasB.position.y = y;
        this.lineKykkasB.position.z = mmTo3D(distance);
        this.lineKykkasB.scale.x = (crossLine + lineWidth3D) / oneMeter;
    }
}

